import { memo, useMemo } from "react";
import PropTypes from "prop-types";
import { Button, Card, Space, Typography } from "antd";
import "./GetStarted.css";
import { Logo64 } from "../../assets";
import { content } from "./helper";

const GetStarted = memo(function GetStarted({
  type,
  handleGetStarted,
  isLoading,
}) {
  const contentDetails = useMemo(() => {
    if (!type || !content?.[type]) {
      return {};
    }
    return content[type];
  }, [type]);

  return (
    <div className="display-flex-center-h-and-v get-started-container">
      <div className="get-started-gradient-border">
        <Card className="get-started-gradient-card">
          <Space direction="vertical" className="get-started-space">
            <Logo64 />
            <Typography.Title level={1} className="get-started-title">
              {contentDetails?.title}
            </Typography.Title>
            <div className="get-started-text-div">
              <Typography.Text className="get-started-desc-typo">
                {contentDetails?.description}
              </Typography.Text>
            </div>
            <Button
              type="primary"
              block
              size="large"
              className="get-started-button"
              onClick={handleGetStarted}
              loading={isLoading}
            >
              Get Started
            </Button>
          </Space>
        </Card>
      </div>
    </div>
  );
});

GetStarted.propTypes = {
  type: PropTypes.string.isRequired,
  handleGetStarted: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
};

export { GetStarted };
